import type { SVGProps } from 'react';
const SvgCalendarViewDay = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#calendar_view_day_svg__a)">
      <path
        fill="currentColor"
        d="M3 17h18v2H3v-2Zm0-7h18v5H3v-5Zm0-4h18v2H3V6Z"
      />
    </g>
    <defs>
      <clipPath id="calendar_view_day_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgCalendarViewDay;
